import { render, staticRenderFns } from "./QuestionAnswerRow.vue?vue&type=template&id=c6112900&scoped=true&"
import script from "./QuestionAnswerRow.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerRow.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswerRow.vue?vue&type=style&index=0&id=c6112900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6112900",
  null
  
)

export default component.exports